import { FiltroEmpresas, DatosEmpresaTraslado } from "../modelo/EmpresasTrasladadas";

export const CONSULTAR_EMPRESAS_SAT = "CONSULTAR_EMPRESAS_SAT";
export const RESPUESTA_EMPRESAS_TRASLADADA = "RESPUESTA_EMPRESAS_TRASLADADA";
export const ERROR_CONTROLADO_CONSULTA = "ERROR_CONTROLADO_CONSULTA";
export const ERROR_DESCONOCIDO_CONSULTA = "ERROR_DESCONOCIDO_CONSULTA";
export const DESCARGAR_XLS_EMPRESAS = "DESCARGAR_XLS_EMPRESAS";
export const XLS_REPORTE_EMPRESAS_CREADO = "XLS_REPORTE_EMPRESAS_CREADO";
export const LIMPIAR_MENSAJES_EMPRESAS = "LIMPIAR_MENSAJES_EMPRESAS";

export const consultarEmpresasSAT = (filtro: FiltroEmpresas) => ({ type: CONSULTAR_EMPRESAS_SAT, filtro });
export const empresasSATConsultadas = (datosEntidad: Array<DatosEmpresaTraslado>, paginas: number, totalDatos: number, consecutivoProceso: number, error: string) => ({
    type: RESPUESTA_EMPRESAS_TRASLADADA, datosEntidad, paginas, totalDatos, consecutivoProceso, error });
export const errorControladoConsulta = (mensajeRespuesta: string) => ({ type: ERROR_CONTROLADO_CONSULTA, mensajeRespuesta });
export const descargarXLSEmpresas = (datosEmpresas: Array<DatosEmpresaTraslado>) => ({ type: DESCARGAR_XLS_EMPRESAS, datosEmpresas });
export const errorDesconocidoConsulta = () => ({ type: ERROR_DESCONOCIDO_CONSULTA });
export const xlsReporteEmpresasCreado = () => ({ type: XLS_REPORTE_EMPRESAS_CREADO });
export const limpiarMensajesEmpresas = () => ({type: LIMPIAR_MENSAJES_EMPRESAS});




// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/empresas_trasladadas/modulos/empresasTrasladadasActions.ts